export const SUPPORTED_LANGUAGES = [
    // 'de',
    // 'es',
    // 'fr',
    'nl',
    // 'pl',
    // 'gb',
] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'nl';

export type Language = {
    code: SupportedLanguage;
    name: string;
};

export const LANGUAGES: Language[] = [
    // {
    //     code: 'de',
    //     name: 'Deutsch',
    // },
    // {
    //     code: 'es',
    //     name: 'Español',
    // },
    // {
    //     code: 'fr',
    //     name: 'Français',
    // },
    {
        code: 'nl',
        name: 'Nederlands',
    },
    // {
    //     code: 'gb',
    //     name: 'English',
    // },
    // {
    //     code: 'pl',
    //     name: 'Polski',
    // },
] as const;
